import { queryOptions } from '@tanstack/react-query';
import API from '@/api';
import { queryKeys } from '@/api/utils/queryKeys';

export const paymentQueryOptions = () =>
  queryOptions({
    queryKey: queryKeys.UK.payment,
    queryFn: API.UK.paymentProvider.getPayment,
  });
